import { ReactElement, useCallback } from 'react';

import {
  NavigationListProps,
  NavigationItemEvent,
  NavigationListItemData,
} from './types';
import NavigationListItem from './ListItem';
import { NavigationListContainer } from './styles';

const NavigationList = ({
  items,
  activeItem,
  onClickItem,
}: NavigationListProps): ReactElement => {
  const getIsActiveCurrenItem = useCallback(
    (currentItem: NavigationItemEvent) =>
      activeItem === currentItem.id || activeItem === currentItem.path,
    [activeItem],
  );

  const getIsSelfOrChildActive = useCallback(
    (currentItem: NavigationListItemData) =>
      getIsActiveCurrenItem(currentItem) ||
      (currentItem.children ?? []).some(getIsActiveCurrenItem),
    [getIsActiveCurrenItem],
  );

  return (
    <NavigationListContainer>
      {items.map(
        ({ enabled = true, ...item }) =>
          enabled && (
            <NavigationListItem
              key={`navigation-list-item-${item.id}`}
              isActive={getIsSelfOrChildActive(item)}
              isExpanded={
                Boolean(item.children?.length) && getIsSelfOrChildActive(item)
              }
              activeItem={activeItem}
              onClick={onClickItem}
              {...item}
            />
          ),
      )}
    </NavigationListContainer>
  );
};

export default NavigationList;
